<template>
  <el-dropdown style="padding:0px" @command="handleCommand">
    <span class="el-dropdown-link">
      <!-- 下拉菜单 -->
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="">全部</el-dropdown-item>
      <el-dropdown-item command="1">启用</el-dropdown-item>
      <el-dropdown-item command="-1">禁用</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
 
<script>
export default {
  data() { 
    return {
      value: ""
    };
  },
  props: {
    options: {
      type: Array,
      default: function() {
        return [
          { label: "全部", value: "全部" },
          { label: "未排课", value: "1" },
          { label: "开课中", value: "4" },
          { label: "已排课", value: "2" },
          { label: "已结束", value: "3" },
        ];
      }
    }
  },
  watch: {
    defaultValue(newVal, oldVal) {
      let self = this;
      self.value = newVal;
    }
  },
  methods: {
    handleCommand(command) {
      this.$emit("selectChange", command);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/agentUserInfo/SelectHeaderAdmin.vue